import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import ReactPlayer from 'react-player';
import InstagramEmbed from 'react-instagram-embed';

class BlogEmbedded extends React.Component {
    constructor(props) {
        super(props);
    }

    embedPicture(data) {
        return (
            <span className="image fit">
                <a href={data.embed_url} target="_blank"><img src={data.url} alt="" /></a>
                Credits {data.author_name && data.author_url ? (
                    <a href={data.author_url} target="_blank">{data.author_name}</a>
                ) : (
                    <a href={data.embed_url} target="_blank">{data.embed_url}</a>
                )}
            </span>
        )
    }

    embedVideo(data){
        return (
            <div className="player-wrapper">
            <ReactPlayer
                className="react-player"
                url={data.embed_url}
                width="100%"
                height="100%"
            />
            </div>
        )
    }

    embedRich(data) {
        switch(data.provider_name) {
            case 'Instagram':
                return (
                    <div className="embeddedSlice">
                    <InstagramEmbed
                        url={data.embed_url}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                    />
                    </div>
                )
            default:
                return (
                    <div className="embeddedSlice">
                        {Parser(data.html)}
                    </div>
                )
        }
    }

    embedLink(data) {
        return (
            <div className="embeddedSlice">
                {Parser(data.html)}
            </div>
        )
    }

    render() {
        const {input} = this.props
        let oembedData = input.primary.external_content
        switch(oembedData.type) {
            case 'link':
                return this.embedLink(oembedData)
            case 'rich' :
                return this.embedRich(oembedData)
            case 'photo':
                return this.embedPicture(oembedData)
            case 'video':
                return this.embedVideo(oembedData)
            default:
                return null
        }
    }
}
BlogEmbedded.propTypes = {
    input: PropTypes.object.isRequired,
};

export default BlogEmbedded;